module.exports = __webpack_public_path__ + "static/media/speed.3c0242b8.svg";